(function () {
  const ROOT_SELECTOR = '[data-home-product-carousel]';

  function destroyCarousel(root) {
    if (root._embla) {
      root._embla.destroy();
      root._embla = null;
    }

    delete root.dataset.emblaInitialized;
  }

  function initCarousel(root) {
    if (root.dataset.emblaInitialized === 'true') return;
    if (typeof EmblaCarousel === 'undefined') return;

    const viewport = root.querySelector('[data-embla-viewport]');
    if (!viewport) return;

    const prevBtns = root.querySelectorAll('[data-embla-prev]');
    const nextBtns = root.querySelectorAll('[data-embla-next]');

    const embla = EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false,
    });

    root._embla = embla;
    root.dataset.emblaInitialized = 'true';

    const updateButtons = () => {
      const canScrollPrev = embla.canScrollPrev();
      const canScrollNext = embla.canScrollNext();

      prevBtns.forEach((button) => {
        button.disabled = !canScrollPrev;
      });

      nextBtns.forEach((button) => {
        button.disabled = !canScrollNext;
      });
    };

    embla.on('select', updateButtons);
    embla.on('reInit', updateButtons);
    updateButtons();

    if (!root._emblaClickHandler) {
      root._emblaClickHandler = (event) => {
        if (!root._embla) return;

        if (event.target.closest('[data-embla-prev]')) {
          root._embla.scrollPrev();
        }

        if (event.target.closest('[data-embla-next]')) {
          root._embla.scrollNext();
        }
      };

      root.addEventListener('click', root._emblaClickHandler);
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      destroyCarousel(root);
      initCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
